import { render, staticRenderFns } from "./ActivityFooter.vue?vue&type=template&id=61960d34&scoped=true&"
import script from "./ActivityFooter.vue?vue&type=script&lang=js&"
export * from "./ActivityFooter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFooter.vue?vue&type=style&index=0&id=61960d34&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61960d34",
  null
  
)

component.options.__file = "ActivityFooter.vue"
export default component.exports